const doc = [({"en":({"js":({"admin":({"photo_sessions":({"show":({"index":({"photo_session_for":"Photo session for: %{name}"})})})})})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;